<template>
  <div>
    <div
      v-if="consumable"
    >
      <header class="content-header">
        <h2 class="mb-0 pb-0h" :style="{ color: consumable.color }">
          {{ consumable.name }}
        </h2>
      </header>

      <CanisterView
        v-if="consumable && consumable.canister"
        :canister="consumable.canister"
        :color="consumable.color"
      />

      <ElectrodeView
        v-if="consumable && consumable.electrode"
        :electrode="consumable.electrode"
        :color="consumable.color"
      />

      <TubeView
        v-if="consumable && consumable.tube"
        :tube="consumable.tube"
        :color="consumable.color"
      />
    </div>
    <div v-else>
      <BtnComponent loading block disabled large />
    </div>
  </div>
</template>

<script>
import { ViewQuery } from '@acs/components-library/src/gql/live/ConsumableDetail.js';

import CanisterView from '../components/consumableDetail/canisterView.vue';
import TubeView from '../components/consumableDetail/tubeView.vue';
import ElectrodeView from '../components/consumableDetail/electrodeView.vue';
import BtnComponent from '@acs/components-library/src/components/common/Btn.vue';

export default {
  name: 'ConsumableDetail',
  components: {
    BtnComponent,
    ElectrodeView,
    TubeView,
    CanisterView,
  },
  props: {
    consumableType: {
      type: String,
      required: true,
    },
  },
  apollo: {
    unitBySerialNumber: {
      query: ViewQuery,
      variables() {
        return {
          sn: this.sn,
        };
      },
      skip() {
        return !this.sn;
      },
    },
  },
  computed: {
    sn() {
      return this.$route.params.sn || null;
    },
    consumable() {
      if (!this.unitBySerialNumber) return null;
      return this.unitBySerialNumber.consumables
        .find((consumable) => consumable.type === this.consumableType);
    },
  },
};
</script>

<style lang="scss" scoped>
.btn.local {
  height: 2.5rem;
}
span.large-text {
  font-size: 1.5rem;
  line-height: 1.5rem;
}
span.medium-text {
  font-size: 1rem;
  line-height: 1.5rem;
}
</style>
